module.exports = __webpack_public_path__ + "static/media/gg_titlebar_select_arrow.9152817c.svg";